export default {"body":"fsWrUa_body","title":"fsWrUa_title","copy":"fsWrUa_copy","notice":"fsWrUa_notice",}